import createClient from 'openapi-fetch';
import type { paths } from '@/generated/openapi-types';

/**
 * Typed `fetch` wrapper over the STR API.
 *
 * Every call (`apiClient.GET`, `.POST`, `.PUT`, `.DELETE`) is validated
 * against the `paths` interface generated from `openapi.yaml`. Wrong
 * path, wrong method, wrong body shape, wrong response handling are all
 * compile errors — we never have to keep hand-written endpoint shapes
 * in sync with the spec.
 *
 * Base URL defaults to `/api/v1` so the client and API are same-origin
 * in production (no CORS, cookies first-party). Override with
 * `VITE_API_BASE_URL` only when pointing the dev SPA at a non-local API.
 *
 * `credentials: 'include'` keeps the Better Auth session cookie attached
 * across same-origin requests; the dev-server proxy in `vite.config.ts`
 * preserves cookies in both directions.
 */
/**
 * Resolved API base URL. Exported so other transports that need to
 * speak the same origin convention as `apiClient` — currently the
 * SSE feedback bridge (`editor/feedback/sse-bridge.ts`), which uses
 * `${apiBaseUrl}/thought-records/{id}/sections/{name}/feedback` —
 * read the same value instead of re-deriving it from env.
 */
export const apiBaseUrl =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';

export const apiClient = createClient<paths>({
  baseUrl: apiBaseUrl,
  credentials: 'include',
});
